import bb from '../components/bb.svg';
import './AnimIntro.scss';

export default () => {
  return (
    <div className="anim_intro">
      <img src={bb} alt="La belle bringue" />
    </div>
  );
}